module.exports = __webpack_public_path__ + "img/resource3.9c968b37.png";